module.exports = __webpack_public_path__ + "img/mainback.a7cf765c.png";